/* MOVIQ Sports — uitklapmenu in de header (desktop)
   Zet de lijst met subcategorieën direct onder het menu-item waar de muis (of focus) op staat,
   zodat je alleen omlaag hoeft te bewegen. Alleen voor tekstmenu's (zonder afbeeldingen).
   De opmaak staat in assets/moviq-layout.css. */
(() => {
  if (window.__moviqMenu) return;
  window.__moviqMenu = true;

  const place = (item) => {
    const submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!submenu) return;
    const grid = submenu.querySelector('.mega-menu__grid');
    if (!grid || grid.querySelector('.mega-menu__link-image')) return;
    const title = item.querySelector('.menu-list__link-title') || item;

    grid.style.setProperty('--moviq-sub-x', '0px');
    const area = grid.parentElement.getBoundingClientRect();
    const start = grid.getBoundingClientRect();
    const target = title.getBoundingClientRect();

    const paddingLeft = parseFloat(getComputedStyle(grid.parentElement).paddingLeft) || 0;
    const paddingRight = parseFloat(getComputedStyle(grid.parentElement).paddingRight) || 0;
    const maxOffset = Math.max(0, area.right - paddingRight - start.left - start.width);
    const titlePadding = parseFloat(getComputedStyle(title).paddingLeft) || 0;

    let offset = target.left + titlePadding - start.left;
    offset = Math.min(Math.max(0, offset), maxOffset);
    if (paddingLeft < 0) offset = 0;
    grid.style.setProperty('--moviq-sub-x', `${Math.round(offset)}px`);
  };

  const handle = (event) => {
    const item = event.target.closest?.('.header-menu .menu-list__list-item:not([slot="overflow"])');
    if (item) place(item);
  };

  document.addEventListener('pointerover', handle, { passive: true });
  document.addEventListener('focusin', handle);
})();